import React from 'react';
import Hero from './Hero';
import Problem from './Problem';
import Solution from './Solution';
import HowItWorks from './HowItWorks';
import WhoIsItFor from './WhoIsItFor';
import CTA from './CTA';
import Footer from './Footer';

function LandingPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <WhoIsItFor />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage; 